import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { FormSection, getFormValues, change as formChange } from 'redux-form';
import { TextAreaField } from 'jbc-front/components/Form';
import { EMPLOYEE_FORM } from 'src/constants/FormNames';
import { exceededLength1500 } from 'src/utils/CustomValidators';

class EmployeeRemarks extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { t } = this.props;
        return (
            <div>
                <FormSection name="employee">
                    <TextAreaField label={t('features.Employees.components.Remarks.remarks')} type="string" name="remarks" validate={exceededLength1500} />
                </FormSection>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return({
        employeeRemarks: getFormValues(EMPLOYEE_FORM)(state).remarks
        // taxScheduleClassifications: getRadioOptions(state, 'taxScheduleClassifications'),
        // taxOnTaxStatuses: getRadioOptions(state, 'taxOnTaxStatuses'),
        // enable: getFormValues(EMPLOYEE_FORM)(state).employeeTaxCalculationSettings.isTaxCalculation,
        // child: getFormValues(EMPLOYEE_FORM)(state).employeeTaxCalculationSettings.isChildAllowance,
        // parents: getFormValues(EMPLOYEE_FORM)(state).employeeTaxCalculationSettings.isParentsAllowance,
        // marriageStatus: getFormValues(EMPLOYEE_FORM)(state).employeeTaxCalculationSettings.isParentsAllowance,
    })
};

export default connect(mapStateToProps)(withTranslation()(EmployeeRemarks));